// extracted by mini-css-extract-plugin
module.exports = {"careerSection":"CareerSections_careerSection__10YS6","spanStyling":"CareerSections_spanStyling__10jNE","heading":"CareerSections_heading__2Jdck"};